import { TankDataProps } from "../controller/tankController";

export function formatTimeAgo(dateString: string | undefined): string {
  if (!dateString) return "Nil";

  try {
    const date = new Date(dateString);
    const now = new Date();
    const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);

    // Handle future dates
    if (seconds < 0) return "in the future";

    // Convert to appropriate time unit
    const intervals = {
      year: 31536000,
      month: 2592000,
      week: 604800,
      day: 86400,
      hour: 3600,
      minute: 60,
      second: 1,
    };

    for (const [unit, secondsInUnit] of Object.entries(intervals)) {
      const interval = Math.floor(seconds / secondsInUnit);

      if (interval >= 1) {
        return interval === 1 ? `1 ${unit} ago` : `${interval} ${unit}s ago`;
      }
    }

    return "just now";
  } catch (error) {
    console.error("Error formatting date:", error);
    return "Nil";
  }
}

function TankDetails(props: TankDataProps) {
  function getTankStatus(tankLevel: string | number | undefined): string {
    if (tankLevel === undefined) return "Nil";

    const level = Number(tankLevel);

    if (level < 40) return "Low";
    if (level >= 40 && level <= 50) return "Average";
    if (level > 50 && level <= 70) return "Moderate";
    if (level > 70) return "Good";

    return "Nil";
  }
}
